import dynamic from 'next/dynamic'

import { WrapperTokensFlowProvider } from '@/components/base/WrappedTokensFlow/context'
import { SellProvider } from '@/components/sell-form/context'
import { isInstantWireMode } from '@/constants/index'
import { MainLayout } from '@/root/src/layouts'
import gssp from '@/utils/gssp'

const P2PCreateOfferForm = dynamic(
  () => import('@/components/p2p-market/create-offer'),
  { ssr: false },
)

const P2PMarketCreateOffer = () => {
  const isInstantWire = isInstantWireMode()

  return (
    <MainLayout>
      <SellProvider>
        {isInstantWire ? (
          <P2PCreateOfferForm />
        ) : (
          <WrapperTokensFlowProvider>
            <P2PCreateOfferForm />
          </WrapperTokensFlowProvider>
        )}
      </SellProvider>
    </MainLayout>
  )
}

export const getServerSideProps = gssp()

export default P2PMarketCreateOffer
